import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

import { ApiError } from '@/api/client'
import { Shell } from '@/components/layout/Shell'
import { Toaster } from '@/components/ui/Toast'
import { AuthGate } from '@/features/auth/AuthGate'
import { JobsPage } from '@/features/jobs/JobsPage'
import { OverviewPage } from '@/features/overview/OverviewPage'
import { CompaniesPage } from '@/features/companies/CompaniesPage'
import { CompanyDetailPage } from '@/features/companies/CompanyDetailPage'
import { SchedulerPage } from '@/features/scheduler/SchedulerPage'

import '@/styles/index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      refetchOnWindowFocus: false,
      // 4xx will not fix itself; retry only server and network errors.
      retry: (count, error) => count < 2 && !(error instanceof ApiError && error.status >= 400 && error.status < 500),
    },
  },
})

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthGate>
        <BrowserRouter>
          <Routes>
            <Route element={<Shell />}>
              <Route index element={<OverviewPage />} />
              <Route path="companies" element={<CompaniesPage />} />
              <Route path="companies/:id" element={<CompanyDetailPage />} />
              <Route path="jobs" element={<JobsPage />} />
              <Route path="scheduler" element={<SchedulerPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthGate>
      <Toaster />
    </QueryClientProvider>
  </StrictMode>,
)
